import { defineComponent as _defineComponent } from 'vue';
import localize from "@/utils/localization";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OverviewPage',
    props: {
        title: null
    },
    setup(__props) {
        return { __sfc: true, localize, Heading };
    }
});
